/*
 * File: FancyDatePicker.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 17 Dec 2021 3:05:19 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { DatePicker } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { FC, useRef, useState } from 'react';

interface FancyDatePickerProps {
  value: string | undefined;
  placeHolder: string;
  disabled?: boolean;
  width?: number;
  onInputChange: (date: any, dateString: any) => void;
  defaultValue?: string;
}

const styles: InlineStylesModel = {
  form: {
    position: 'relative'
  },
  borderAnimation: {
    // transform: 'translateX(-100%)',
    transition: 'all 0.3s ease'
  },
  input: {
    width: '100%',
    minWidth: 125
  },
  labelUnfocused: {
    position: 'absolute',
    color: 'rgba(0,0,0,0.50)',
    top: 5,
    left: 10,
    transition: 'all 0.3s ease'
  },
  labelFocused: {
    backgroundColor: 'white',
    position: 'absolute',
    paddingLeft: 5,
    paddingRight: 5,
    top: -15,
    left: 8,
    transition: 'all 0.3s ease'
  }
};

export const FancyDatePicker: FC<FancyDatePickerProps> = ({ value, placeHolder, onInputChange, disabled, width, defaultValue }: FancyDatePickerProps) => {
  const [isLabelTop, _setIsLabelTop] = useState(false);

  const inputRef = useRef(null);

  const inputWidth = width ? { ...styles.input, ...{ width } } : styles.input;

  const handleFocus = (): void => {
    _setIsLabelTop(true);
  };

  const onLabelClick = (): void => {
    if (!isLabelTop) {
      _setIsLabelTop(true);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (inputRef.current as any).focus();
    }
  };

  const handleBlur = (): void => {
    if (!value) {
      _setIsLabelTop(false);
    }
  };

  return (
    <div style={{ ...styles.form, ...styles.borderAnimation }}>
      <DatePicker ref={inputRef} style={inputWidth} onFocus={handleFocus} onBlur={handleBlur} onChange={onInputChange} allowClear disabled={disabled} />
      <label style={styles.labelFocused} onClick={onLabelClick}>
        <span>{placeHolder}</span>
      </label>
    </div>
  );
};
